import { BRAND, OPERATING_MODEL } from "@/data/content";
import { Reveal } from "@/components/site/Reveal";
import { SectionHeading } from "@/components/site/SectionHeading";

export const OperatingModel = () => (
  <section
    id="approach"
    data-testid="approach-section"
    className="relative isolate overflow-hidden border-t border-border/70 py-24 lg:py-36"
  >
    <img
      src={BRAND.symbol}
      alt=""
      aria-hidden="true"
      className="pointer-events-none absolute -left-24 bottom-0 -z-10 w-[360px] opacity-[0.05] lg:w-[480px]"
    />

    <div className="shell">
      <SectionHeading
        eyebrow={OPERATING_MODEL.eyebrow}
        lines={OPERATING_MODEL.headline}
      />

      <div className="mt-16 lg:mt-24">
        <div className="hairline" />
        <ol className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
          {OPERATING_MODEL.stages.map((stage, i) => (
            <Reveal key={stage.title} delay={0.08 * i} className="h-full">
              <li
                data-testid={`approach-stage-${stage.index}`}
                className="group relative h-full border-b border-border/70 py-10 pr-8 sm:border-r lg:py-14 [&:nth-child(2n)]:sm:border-r-0 lg:[&:nth-child(2n)]:border-r lg:[&:nth-child(4n)]:border-r-0"
              >
                <span className="absolute left-0 top-0 h-px w-0 bg-aqua-bright transition-all duration-700 group-hover:w-full" />
                <span className="font-mono text-[11px] tracking-[0.3em] text-aqua">
                  {stage.index}
                </span>
                <h3 className="display mt-8 text-2xl text-offwhite lg:text-3xl">
                  {stage.title}
                </h3>
                <p className="mt-5 max-w-xs text-sm leading-relaxed text-mist">
                  {stage.detail}
                </p>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </div>
  </section>
);
